import Image from 'next/image'
import React from 'react'
import BannerImage from '@/assets/about-us/about-us-banner.webp'
import { Col } from 'react-bootstrap'
import Pill from '@/components/base/Pill'
import { FiCodesandbox } from 'react-icons/fi'

const Banner = () => {
	return (
		<div className='about-us-banner'>
			<Col md={6} xs={12}>
				<div className='display-laptop-view'>
					<Pill text='About Us' icon={<FiCodesandbox />} type='primary' />
				</div>

				<h2>
					<span className='primary-text'>Largest Vertically Integrated</span> Metal Supply Chain Platform
				</h2>
			</Col>
			<Col md={6} xs={12}>
				<Image className='circle-img' src={BannerImage} alt='..' />
			</Col>
		</div>
	)
}

export default Banner
